import React, { useEffect, useState } from "react";
import { numOfPage, SellerLedgerListing } from "../../../constant";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BatchPagination from "../../batch/BatchPagination";
import _ from "lodash";
import { getSellerLedgerTotals } from "../../../store/actions/accounts.action";
import ProductListingFilter from "../../Inventory/Product/ProductListingFilter";
import DataTable from "../../common/DataTable";
import moment from "moment";
import SearchCarrierConnect from "../../CarrierConnect/SearchCarrierConnect";

/* istanbul ignore next */
const SellerLedgerList = () => {
    const { sellerLedgerList, sellerLedgerListStatus } = useSelector((state) => state.accountingReducer);
    const { showAccountingMenu } = useSelector((state) => state.accountingReducer);
    const [loader, setLoader] = useState(false);
    const [sellerList, setSellerList] = useState([]);
    const [allSellers, setAllSellers] = useState([]);
    const [resetTrigger, setResetTrigger] = useState(0);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        if (sellerLedgerListStatus === "PENDING") {
            setLoader(true);
        } else if (sellerLedgerListStatus === "SUCCESS") {
            setfilterData({
                ...filterData,
                totalPages: Math.ceil(sellerLedgerList.TotalRecords / filterData.pageSize),
            });
            setLoader(false);
        }
    }, [sellerLedgerListStatus]);

    let payloadData = {
        pageIndex: 1,
        pageSize: 30,
        totalPages: 1,
        sortColumn: '',
        sortOrder: 'DESCENDING',
        searchText: '',
        sellerIdList: [],
        companyIdList: [],
        showFilter: false,
        showSearch: false,
        startDate: null,
        endDate: null,
    }

    const [filterData, setfilterData] = useState({ ...payloadData });

    const fetchLedgerList = (dataParam = null) => {
        const source = dataParam || filterData;
        let data = {
            ...source,
            companyIdList: _.map(source.companyIdList, "Id"),
            sellerIdList: _.map(source.sellerIdList, "id"),
            searchText: source.searchText.trim(),
        };

        dispatch(getSellerLedgerTotals(data));
    };

    useEffect(() => {
        fetchLedgerList();
    }, [filterData.pageSize, filterData.pageIndex, filterData.sortColumn, filterData.sortOrder, resetTrigger]);

    const handleAction = (item) => {
        navigate(`/accounting/ledger`, {
            state: {
                ledgerDetail: item,
                companyId: item.entryCompanyId,
                companyName: item.companyName,
                sellerName: item.sellerName,
                sellerId: item.entrySellerId,
            }
        });
    };

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
        });
    };

    const handleSearchText = (value) => {
        setfilterData({
            ...filterData,
            searchText: value
        })
    };

    const handleReset = () => {
        setfilterData(prev => {
            const updated = { ...prev, pageIndex: 1, searchText: '' };
            fetchLedgerList(updated);
            return updated;
        });
    };

    const handleFilterReset = () => {
        setfilterData({ ...payloadData });
        setResetTrigger(prev => prev + 1); // force rerun
    };

    const handleDateFieldChange = (date, fieldName) => {
        setfilterData({
            ...filterData,
            [fieldName]: moment(date).format("YYYY-MM-DDTHH:mm:ss"),
        });
    };

    const handleSearchFilter = () => {
        setfilterData({ ...filterData, pageIndex: 1 });
        if (filterData.pageIndex === 1) {
            fetchLedgerList();
        }
    };

    return (
        <div className={` ${showAccountingMenu ? 'col-10' : 'col-12'}`}>
            <div className="main__tile_heading cus-btn-include-sec zIndex2">
                <span>
                    Seller Ledger
                </span>
                <div className='inlineFlex fontFix'>
                    <div className='filterBtnWapper'>
                        <button className="btn cus-seconday-bg-btn openSearch" onClick={() => setfilterData({ ...filterData, showFilter: !filterData.showFilter })}>
                            Filter
                        </button>
                    </div>
                </div>
            </div>

            {filterData.showFilter && (
                <ProductListingFilter
                    showFilter={filterData.showFilter}
                    dispatch={dispatch}
                    useSelector={useSelector}
                    filterData={filterData}
                    setfilterData={setfilterData}
                    fetchProductList={fetchLedgerList}
                    handleReset={handleFilterReset}
                    sellerList={sellerList}
                    setSellerList={setSellerList}
                    allSellers={allSellers}
                    setAllSellers={setAllSellers}
                    handleDateFieldChange={handleDateFieldChange}
                    type={'sellerLedger'}
                />
            )}

            <div className='zIndex2'>
                <SearchCarrierConnect
                    searchKeyword={filterData.searchText}
                    handleSearchText={handleSearchText}
                    handleSearchFilter={handleSearchFilter}
                    handleReset={handleReset}
                    placeholderText="Search by Company or Seller"
                />
            </div>

            <div className="main_content_table_history">
                <div className="tableFixHead incomingTbl">
                    <div className="incomingTbl p-3">
                        <DataTable
                            headers={SellerLedgerListing}
                            tableData={sellerLedgerList.list || []}
                            actionType={9}
                            handleAction={handleAction}
                            handleSortingColumn={handleSortingColumn}
                            dataStatus={sellerLedgerListStatus}
                            filterData={filterData}
                        />
                    </div>
                </div>
            </div>

            <BatchPagination
                gridData={sellerLedgerList.list || []}
                totalVisualRecords={sellerLedgerList?.list?.length || 0}
                numberOfPage={filterData.pageSize}
                numOfPage={numOfPage}
                loader={loader}
                currentPage={filterData.pageIndex}
                totalPages={filterData.totalPages}
                totalRecords={sellerLedgerList.TotalRecords}
                setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value, pageIndex: 1 })}
            />
        </div>
    )
};
export default SellerLedgerList;